<script>
  export let message;
</script>

<style>
  p {
    font-size: 40px;
    font-family: "Lato";
    font-weight: 200;
    text-align: center;
  }
</style>

<p>🎉 {message} 🍾</p>
